module.exports = __webpack_public_path__ + "img/atomic_03.2d34e2cb.png";